'use client';

import { CustomHeaderContact } from '@/components/CustomLayout/CustomHeaderContact';
import { LayoutContext } from '@/contexts/LayoutContext';
import { LayoutReducerActionType } from '@/types/layout';
import { IInventory, InventoryField } from '@lamesarv-sdk/types';
import { IContactItem } from '@/types/layout';
import { useContext, useEffect } from 'react';

export interface IPdpCustomHeaderProps {
  item: IInventory;
}

export const PdpCustomHeader = ({ item }: IPdpCustomHeaderProps) => {
  const { context: layoutContext, dispatch: layoutDispatch } = useContext(LayoutContext);

  const customContactItems: IContactItem[] = [];
  let customMatch = false;

  layoutContext?.contactItems
    ?.filter((item) => item.custom_item || item.always_include)
    ?.forEach((contact) => {
      if (contact.always_include) {
        customContactItems.push(contact);
        return;
      }

      const baseItemStatus = item[InventoryField.inventoryType]?.toLowerCase() || '';

      const matchStatus =
        !contact.inventory_status || contact.inventory_status == 'all' || contact.inventory_status === baseItemStatus;

      const baseItemMake = item[InventoryField.make]?.toLowerCase() || '';
      const baseItemModel = item[InventoryField.model]?.toLowerCase() || '';
      const baseItemTitle = item[InventoryField.title]?.toLowerCase() || '';

      const matchMakers =
        contact.inventory_maker
          ?.split(',')
          .map((maker) => maker.toLowerCase().trim())
          .filter(Boolean) || [];
      const matchModels =
        contact.inventory_model
          ?.split(',')
          .map((model) => model.toLowerCase().trim())
          .filter(Boolean) || [];
      const matchTitleContains =
        contact.inventory_title_contains
          ?.split(',')
          .map((title) => title.toLowerCase().trim())
          .filter(Boolean) || [];

      const hasAnyFilter = matchMakers.length > 0 || matchModels.length > 0 || matchTitleContains.length > 0;

      const match =
        hasAnyFilter &&
        matchStatus &&
        (matchMakers.length === 0 || matchMakers.includes(baseItemMake)) &&
        (matchModels.length === 0 || matchModels.includes(baseItemModel)) &&
        (matchTitleContains.length === 0 || matchTitleContains.some((title) => baseItemTitle.includes(title)));

      if (match) {
        customContactItems.push(contact);
        customMatch = true;
      }
    });

  const defaultContactItem =
    customContactItems.find((contact) => contact.default) ||
    layoutContext?.contactItems?.find((contact) => contact.default);

  useEffect(() => {
    if (layoutContext?.defaultContactItem?.url === defaultContactItem.url) return;

    layoutDispatch({
      type: LayoutReducerActionType.updateDefaultContactItem,
      payload: defaultContactItem,
    });
  }, [defaultContactItem, layoutContext?.defaultContactItem, layoutDispatch]);

  return customMatch && customContactItems.length > 0 ? (
    <CustomHeaderContact contact_items={customContactItems} />
  ) : null;
};
